import { Component } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html'
})
export class ErrorPageComponent {
  constructor(private navigationService: NavigationService){}

  goBack(){
    this.navigationService.goBack();
  }
}
